export enum InviteSource {
  WebFrontDesk = 1,
  WebUserCenter,
  Client,
}

export enum AnimationInviteCount {
  /** 0 表示没有邀请过 */
  None = 0,
  /** 1 表示邀请过1次 */
  Once = 1,
  /** 2 表示邀请过2次 */
  Twice = 2,
}
